import type { SupabaseClient } from '@supabase/supabase-js';

export interface ProductReviewFeatures {
  halfStars: boolean;
  reviewActivity: boolean;
}
export async function getProductReviewFeatures(
  client: SupabaseClient,
  signal?: AbortSignal,
): Promise<ProductReviewFeatures> {
  try {
    const request = client.rpc('product_review_features');
    const result = await request.abortSignal(signal ?? AbortSignal.timeout(5000));
    const valid =
      !result.error &&
      typeof result.data?.half_stars === 'boolean' &&
      typeof result.data?.review_activity === 'boolean';
    return {
      halfStars: valid && result.data.half_stars === true,
      reviewActivity: valid && result.data.review_activity === true,
    };
  } catch {
    return { halfStars: false, reviewActivity: false };
  }
}
